import { useEffect, useRef, useState } from 'preact/hooks';

type TitleObserverOptions = {
  onVisible: () => string;
  onInvisible: () => string;
};

export default function useTitleObserver({
  onVisible,
  onInvisible
}: TitleObserverOptions) {
  const [title, setTitle] = useState(onVisible());
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return () => {};

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const newTitle = entry.isIntersecting ? onVisible() : onInvisible();

          if (title !== newTitle) {
            setTitle(newTitle);
          }
        });
      },
      {
        root: null,
        threshold: 0
      }
    );

    observer.observe(ref.current);

    return () => ref.current && observer.unobserve(ref.current);
  }, [onVisible, onInvisible]);

  return { ref, title };
}
